import { TFunction } from '@mint-lib/i18n';

export enum IntegrationStatusFilters {
  all = 'all',
  integrated = 'integrated',
  notIntegrated = 'notIntegrated',
}

export const statusFilters = (t: TFunction) => [
  {
    id: IntegrationStatusFilters.all,
    label: t('See all'),
  },
  {
    id: IntegrationStatusFilters.integrated,
    label: t('Integrated'),
  },
  {
    id: IntegrationStatusFilters.notIntegrated,
    label: t('Not integrated'),
  },
];

export enum sortFilter {
  label = 'label',
  connectionType = 'connectionType',
}
